<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @export="exportFile"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="templateQueryParams"
      :exportOptions="{
        params: {
          billCartonTransferCode: chooseTemplateOptions.billCartonTransferCode,
        },
        checkUrl: '/samplemanage/billCartonTransfer/check',
      }"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/backstage/components/choose-template'
export default {
  components: {
    PageHeader,
    PageMain,
    ChooseTemplate,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: { visible: false, billCartonTransferCode: '' },
      templateQueryParams: { templateGroup: 'admin-cartonTransfer' },
    }
  },
  activated() {
    this.getData(this.$refs.header.getForm())
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .billCartonTransferListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportFile({ billCartonTransferCode, templateGroup }) {
      this.templateQueryParams.templateGroup = templateGroup
      this.chooseTemplateOptions = { visible: true, billCartonTransferCode }
    },
  },
}
</script>
